import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/hardwares/selectors';

export const getState = createSelector(getParent, slice => slice.ui);
